// extracted by mini-css-extract-plugin
export default {"container":"IXfxt8","notFirstItem":"SLeeGn","pimple":"_oxJeb","updatedIndicationText":"dLTgYF"};